import { apiClient } from '../../utils';
import { handleError } from '../handleError';

export const deleteBlogPost = async ({ siteId, bi }) => {
  try {
    const data = {
      id: bi,
      site: siteId,
    };
    const rsp = await apiClient.post('/merchant/blog/remove', {
      data,
    });
    return rsp;
  } catch (e) {
    handleError(e);
    throw e;
  }
};
